import React from "react";
import SEO from '../../seo/SEO'
import ProductBanner from "./ProductBanner/ProductBanner";
import First_ProductSection from "./First_ProductSection/First_ProductSection";
import ProductPage_New from "./ProductPage_New/ProductPage_New";
import ProductsByZeon from "./ProductsByZeon/ProductsByZeon";

const ProductMain = () => {
  return (
    <>
    <SEO />
    <div>
      <ProductBanner />
      {/* <First_ProductSection/> */}
      <ProductsByZeon/>
      <ProductPage_New/>
      
    </div>
    </>
  );
};

export default ProductMain;